// src/components/Nav.js
import React from 'react';

const Nav = () => {
  return (
    <nav id="nav">
      <ul className="container">
        {/* <li><a href="#top">Top</a></li> */}
        {/* <li><a href="#work">Work</a></li> */}
        <li><a href="#publications">Publications</a></li>
        {/* <li><a href="#contact">Contact</a></li> */}
        <li><a href="/CV.pdf">CV</a></li>
      </ul>
    </nav>
  );
};

export default Nav;